module.exports = __webpack_public_path__ + "static/wpack/extracted/play-2e43bc8027e6eaa9ca2d08dd8385c7f32.svg";